import { FetchFormsRequest } from './../../forms/forms.actions'
import { getFormsState } from './../../forms/forms.selectors'
import Validator from '@shared/validatorjs/src/validator'
import {
  UpdateField,
  SetDefaultData,
  CreateDataCycleRequest,
} from '../data-cycles.actions'
import { getCreateDataCycleState } from '../data-cycles.selectors'
import { Store, select } from '@ngrx/store'
import { Component, OnInit, OnDestroy } from '@angular/core'
import FormTrait from 'src/app/traits/form.trait'
import { Map } from 'immutable'
import { Subscription } from 'rxjs'
import { toDate } from '@shared/shared.utils'

@Component({
  selector: 'app-create-data-cycle',
  templateUrl: './create-data-cycle.component.html',
  styleUrls: ['./create-data-cycle.component.css'],
})
export class CreateDataCycleComponent
  extends FormTrait
  implements OnInit, OnDestroy
{
  public isLoading: boolean
  private state$: Subscription
  public forms: []
  private formsState$: Subscription

  constructor(public store: Store<any>) {
    super()
  }

  ngOnInit() {
    this.store.dispatch<any>(new SetDefaultData('createDataCycle'))

    this.state$ = this.store
      .pipe(select(getCreateDataCycleState))
      .subscribe((state) => {
        this.state = state
        this.isLoading = state.get('isLoading')
      })

    this.formsState$ = this.store
      .pipe(select(getFormsState))
      .subscribe((state) => {
        this.forms = state.get('data').toJS()
      })

    this.store.dispatch<any>(
      new FetchFormsRequest({
        pageSize: 500,
      }),
    )
  }

  ngOnDestroy() {
    this.state$.unsubscribe()
    this.formsState$.unsubscribe()
  }

  public handleFieldChange(e: any, name: null | string = null): void {
    this.store.dispatch(
      new UpdateField(
        name || e.target.name,
        name ? e : e.target.value,
        'createDataCycle.data',
      ),
    )
    this.store.dispatch(
      new UpdateField(
        'validationErrors',
        this.state.get('validationErrors').delete(name || e.target.name),
        'createDataCycle',
      ),
    )
  }

  validation() {
    const data = this.state.get('data')
    const rules = {
      name: 'required',
    }
    const validator = new Validator(
      {
        name: data.get('name'),
      },
      rules,
    )

    return validator
  }

  public onSubmit(e: Event): void {
    e.preventDefault()

    const validation = this.validation()
    const payload = this.state
      .get('data')
      .set(
        'paymentDeadline',
        toDate(this.state.get('data').get('paymentDeadline')),
      )
      .set(
        'proposedEndDate',
        toDate(this.state.get('data').get('proposedEndDate')),
      )
      .set('startDate', toDate(this.state.get('data').get('startDate')))
      .set(
        'earlyPaymentDiscountDeadline',
        toDate(this.state.get('data').get('earlyPaymentDiscountDeadline')),
      )
      .set(
        'earlyPaymentDiscountDeadlineBusiness',
        toDate(
          this.state.get('data').get('earlyPaymentDiscountDeadlineBusiness'),
        ),
      )
      .set(
        'earlyPaymentDiscountDeadlineCompounds',
        toDate(
          this.state.get('data').get('earlyPaymentDiscountDeadlineCompounds'),
        ),
      )
      .toJS()

    if (validation.passes()) {
      this.store.dispatch(new CreateDataCycleRequest(payload))
    } else {
      this.store.dispatch<any>(
        new UpdateField(
          'validationErrors',
          validation.errors.errors,
          'createDataCycle',
        ),
      )
    }
  }
}
